<app-side-menu>
  <div class="service-orders-table">

      <div *ngIf="error" class="alert alert-danger" role="alert">
        <i class="fas fa-exclamation-triangle"></i>
        {{ error }}
      </div>

      <div *ngIf="!error">
        <!-- Seção de Filtros -->
        <div class="filters-section">
          <div class="view-tabs" role="tablist" aria-label="Visualização da lista">
            <button
              type="button"
              class="view-tabs__tab"
              role="tab"
              [class.view-tabs__tab--active]="!filtrosOpen"
              [attr.aria-selected]="!filtrosOpen"
              (click)="showDashboard()">
              <i class="fas fa-chart-pie" aria-hidden="true"></i>
              <span>Dashboard</span>
            </button>
            <button
              type="button"
              class="view-tabs__tab"
              role="tab"
              [class.view-tabs__tab--active]="filtrosOpen"
              [attr.aria-selected]="filtrosOpen"
              (click)="showFilters()">
              <i class="fas fa-filter" aria-hidden="true"></i>
              <span>Filtros</span>
            </button>
          </div>

          <!-- Dashboard -->
          <div class="dashboard-section" *ngIf="!filtrosOpen">
            <div *ngIf="dashboardLoading" class="dashboard-loading">
              <i class="fas fa-spinner fa-spin me-2"></i>
              Carregando dashboard...
            </div>

            <div *ngIf="dashboardError && !dashboardLoading" class="alert alert-warning dashboard-alert" role="alert">
              <i class="fas fa-exclamation-triangle"></i>
              {{ dashboardError }}
            </div>

            <div *ngIf="!dashboardLoading && !dashboardError && dashboardData?.byStatus?.length" class="dashboard-cards-grid">
              <div
                *ngFor="let card of dashboardData!.byStatus; let i = index"
                class="os-dashboard-card"
                [ngClass]="'os-dashboard-card--' + getDashboardCardVariant(card.status, i)">
                <div class="os-dashboard-card__content">
                  <div class="os-dashboard-card__value">{{ card.count }}</div>
                  <div class="os-dashboard-card__label">{{ card.status }}</div>
                </div>
                <div class="os-dashboard-card__chart" [ngClass]="'os-dashboard-card__chart--' + getDashboardChartVariant(i)">
                  <svg viewBox="0 0 120 40" preserveAspectRatio="none" aria-hidden="true">
                    <ng-container [ngSwitch]="getDashboardChartVariant(i)">
                      <polyline
                        *ngSwitchCase="'line'"
                        points="0,32 20,24 40,28 60,14 80,18 100,8 120,12"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        *ngSwitchCase="'area'"
                        d="M0,36 L0,28 C20,22 35,30 55,18 C75,8 95,20 120,10 L120,36 Z"
                        fill="currentColor"
                        opacity="0.35" />
                      <path
                        *ngSwitchCase="'area'"
                        d="M0,28 C20,22 35,30 55,18 C75,8 95,20 120,10"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round" />
                      <g *ngSwitchCase="'bar'">
                        <rect x="8" y="22" width="10" height="14" rx="1" fill="currentColor" opacity="0.55" />
                        <rect x="26" y="14" width="10" height="22" rx="1" fill="currentColor" opacity="0.7" />
                        <rect x="44" y="18" width="10" height="18" rx="1" fill="currentColor" opacity="0.55" />
                        <rect x="62" y="8" width="10" height="28" rx="1" fill="currentColor" opacity="0.85" />
                        <rect x="80" y="16" width="10" height="20" rx="1" fill="currentColor" opacity="0.65" />
                        <rect x="98" y="12" width="10" height="24" rx="1" fill="currentColor" opacity="0.75" />
                      </g>
                    </ng-container>
                  </svg>
                </div>
              </div>
            </div>

            <div *ngIf="!dashboardLoading && !dashboardError && dashboardData && !dashboardData.byStatus.length" class="dashboard-empty">
              <i class="fas fa-chart-pie me-2"></i>
              Nenhum dado de status disponível no dashboard.
            </div>
          </div>
          <div class="filters-header" *ngIf="filtrosOpen">
            <div class="filters-title">
              <i class="fas fa-filter"></i>
              <h3>Filtros</h3>
            </div>
            <div class="filter-actions">
              <button *ngIf="hasActiveFilters()" class="btn btn-clear-filters" (click)="clearFilters()">
                <i class="fas fa-times"></i>
                Limpar Filtros
              </button>
              <button type="button" class="btn btn-success" (click)="openExportModal()">
                <i class="fas fa-file-excel me-2"></i>
                Exportar Excel
              </button>
            </div>
          </div>

          <div class="filters-grid" *ngIf="filtrosOpen">
            <div class="filter-group">
              <label for="filterStatus">
                <i class="fas fa-circle-notch"></i>
                Status
              </label>
              <select id="filterStatus" class="filter-select" [(ngModel)]="selectedStatus" (change)="applyFilters()">
                <option value="">Todos os Status</option>
                <option *ngFor="let status of statusOptions" [value]="status.name">
                  {{ status.name }}
                </option>
              </select>
            </div>

            <div class="filter-group">
              <label for="filterConfigOrder">
                <i class="fas fa-wrench"></i>
                Tipo OS
              </label>
              <select id="filterConfigOrder" class="filter-select" [(ngModel)]="selectedConfigOrderId" (change)="applyFilters()">
                <option [ngValue]="null">Todos os Tipos</option>
                <option *ngFor="let config of configOrderOptions" [ngValue]="config.id">
                  {{ config.typeOS }}
                </option>
              </select>
            </div>

            <div class="filter-group">
              <label for="filterOrderNumber">
                <i class="fas fa-hashtag"></i>
                Nº OS
              </label>
              <input id="filterOrderNumber" type="text" class="filter-input" placeholder="Ex: OS-2026-0001"
                [(ngModel)]="filterOrderNumber" (keyup.enter)="applyFilters()">
            </div>

            <div class="filter-group">
              <label for="filterPlate">
                <i class="fas fa-car"></i>
                Placa
              </label>
              <input id="filterPlate" type="text" class="filter-input" placeholder="Ex: ABC1D23"
                [(ngModel)]="filterPlate" (keyup.enter)="applyFilters()">
            </div>

            <div class="filter-group">
              <label for="filterStartDate">
                <i class="fas fa-calendar-alt"></i>
                Data Início
              </label>
              <input id="filterStartDate" type="date" class="filter-input"
                [(ngModel)]="filterStartDate" (change)="applyFilters()">
            </div>

            <div class="filter-group">
              <label for="filterEndDate">
                <i class="fas fa-calendar-alt"></i>
                Data Fim
              </label>
              <input id="filterEndDate" type="date" class="filter-input"
                [(ngModel)]="filterEndDate" (change)="applyFilters()">
            </div>

            <div class="filter-group">
              <label for="filterB2bContractId">
                <i class="fas fa-building"></i>
                Contrato B2B
              </label>
              <input id="filterB2bContractId" type="number" class="filter-input" placeholder="ID do contrato"
                [(ngModel)]="filterB2bContractId" (keyup.enter)="applyFilters()">
            </div>

            <div class="filter-group">
              <label for="filterIsScheduled">
                <i class="fas fa-calendar-check"></i>
                Agendada
              </label>
              <select id="filterIsScheduled" class="filter-select" [(ngModel)]="filterIsScheduled" (change)="applyFilters()">
                <option value="">Todas</option>
                <option value="true">Sim</option>
                <option value="false">Não</option>
              </select>
            </div>
          </div>

          <!-- Indicadores de Filtros Ativos -->
          <div class="active-filters" *ngIf="hasActiveFilters()">
            <span class="filter-label">Filtros ativos:</span>
            <span class="filter-tag" *ngIf="selectedStatus">
              Status: {{ selectedStatus }}
              <i class="fas fa-times" (click)="selectedStatus = ''; applyFilters()"></i>
            </span>
            <span class="filter-tag" *ngIf="selectedConfigOrderId">
              Tipo OS: {{ getConfigOrderName(selectedConfigOrderId) }}
              <i class="fas fa-times" (click)="selectedConfigOrderId = null; applyFilters()"></i>
            </span>
            <span class="filter-tag" *ngIf="filterOrderNumber">
              Nº OS: {{ filterOrderNumber }}
              <i class="fas fa-times" (click)="filterOrderNumber = ''; applyFilters()"></i>
            </span>
            <span class="filter-tag" *ngIf="filterPlate">
              Placa: {{ filterPlate }}
              <i class="fas fa-times" (click)="filterPlate = ''; applyFilters()"></i>
            </span>
            <span class="filter-tag" *ngIf="filterStartDate">
              De: {{ filterStartDate }}
              <i class="fas fa-times" (click)="filterStartDate = ''; applyFilters()"></i>
            </span>
            <span class="filter-tag" *ngIf="filterEndDate">
              Até: {{ filterEndDate }}
              <i class="fas fa-times" (click)="filterEndDate = ''; applyFilters()"></i>
            </span>
            <span class="filter-tag" *ngIf="filterB2bContractId">
              B2B: {{ filterB2bContractId }}
              <i class="fas fa-times" (click)="filterB2bContractId = ''; applyFilters()"></i>
            </span>
            <span class="filter-tag" *ngIf="filterIsScheduled">
              Agendada: {{ filterIsScheduled === 'true' ? 'Sim' : 'Não' }}
              <i class="fas fa-times" (click)="filterIsScheduled = ''; applyFilters()"></i>
            </span>
          </div>
        </div>

        <!-- Tabela -->
        <app-table
          [searchRight]="true"
          [data]="serviceOrders"
          [columns]="tableColumns"
          [loading]="loading"
          [actions]="tableActions"
          [clickable]="true"
          [showSearch]="true"
          [title]="'Ordens de Serviço'"
          searchPlaceholder="Buscar por OS, cliente, veículo..."
          [totalItemsFromBackend]="totalCount"
          [currentPageFromBackend]="currentPage"
          [itemsPerPage]="pageSize"
          [hasNextPageFromBackend]="currentPage < totalPages"
          [hasPreviousPageFromBackend]="currentPage > 1"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (actionClick)="onTableAction($event)"
          (rowClick)="onRowClick($event)">
          <button
            *appHasPermission="'ServiceOrders.Create'"
            table-header-action
            class="btn btn-primary new-service-order-btn"
            [disabled]="!canCreateServiceOrder()"
            [title]="canCreateServiceOrder() ? 'Criar nova ordem de serviço' : 'Nenhum tipo de OS permitido para criação'"
            (click)="createNewServiceOrder()">
            <i class="fas fa-plus me-2"></i>
            Nova Ordem de Serviço
          </button>
        </app-table>
      </div>
  </div>

  <app-modal
    [isOpen]="showExportModal"
    title="Exportar Ordens de Serviço para Excel"
    [size]="'lg'"
    [closable]="true"
    (close)="closeExportModal()">
    <div class="report-form">
      <div class="report-section mb-4">
        <h5 class="section-title">
          <i class="fas fa-columns me-2"></i>
          Colunas do relatório
        </h5>
        <p class="text-muted small mb-3">Selecione as colunas que deseja incluir na planilha</p>

        <div *ngIf="loadingExportColumns" class="mb-3">
          <i class="fas fa-spinner fa-spin me-2"></i>
          Carregando colunas...
        </div>

        <div class="field-actions mb-3" *ngIf="!loadingExportColumns && availableExportColumns.length">
          <button type="button" class="btn btn-sm btn-outline-primary" (click)="selectAllExportFields()">
            <i class="fas fa-check-double me-1"></i>
            Selecionar todas
          </button>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="deselectAllExportFields()">
            <i class="fas fa-times me-1"></i>
            Desmarcar todas
          </button>
        </div>

        <div *ngIf="!loadingExportColumns && availableExportColumns.length === 0" class="alert alert-info">
          Nenhuma coluna disponível para exportação.
        </div>

        <div class="fields-grid" *ngIf="!loadingExportColumns && availableExportColumns.length">
          <div *ngFor="let field of availableExportColumns" class="field-checkbox">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'export-field-' + field.key"
                [checked]="field.checked"
                (change)="toggleExportField(field.key)">
              <label class="form-check-label" [for]="'export-field-' + field.key">
                {{ field.label }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="report-section mb-4">
        <h5 class="section-title">
          <i class="fas fa-calendar-alt me-2"></i>
          Período (opcional)
        </h5>
        <p class="text-muted small mb-3">Restrinja a exportação por data de abertura</p>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label" for="exportStartDate">Data início</label>
            <input
              id="exportStartDate"
              type="date"
              class="form-control"
              [(ngModel)]="exportStartDate">
          </div>
          <div class="col-md-6">
            <label class="form-label" for="exportEndDate">Data fim</label>
            <input
              id="exportEndDate"
              type="date"
              class="form-control"
              [(ngModel)]="exportEndDate">
          </div>
        </div>
      </div>

      <div class="report-section mb-4">
        <h5 class="section-title">
          <i class="fas fa-filter me-2"></i>
          Filtros (opcional)
        </h5>
        <p class="text-muted small mb-3">Os mesmos filtros podem ser aplicados na exportação</p>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label" for="exportFilterStatus">Status</label>
            <select id="exportFilterStatus" class="form-control form-select" [(ngModel)]="exportFilters.status">
              <option [ngValue]="null">Todos</option>
              <option *ngFor="let status of statusOptions" [ngValue]="status.name">
                {{ status.name }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label" for="exportFilterConfigOrder">Tipo OS</label>
            <select id="exportFilterConfigOrder" class="form-control form-select" [(ngModel)]="exportFilters.configOrderId">
              <option [ngValue]="null">Todos os tipos permitidos</option>
              <option *ngFor="let config of configOrderOptions" [ngValue]="config.id">
                {{ config.typeOS }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label" for="exportFilterOrderNumber">Nº OS</label>
            <input
              id="exportFilterOrderNumber"
              type="text"
              class="form-control"
              [(ngModel)]="exportFilters.orderNumber"
              placeholder="Ex: OS-2026-0001">
          </div>
          <div class="col-md-6">
            <label class="form-label" for="exportFilterPlate">Placa</label>
            <input
              id="exportFilterPlate"
              type="text"
              class="form-control"
              [(ngModel)]="exportFilters.plate"
              placeholder="Ex: ABC1D23">
          </div>
        </div>
      </div>

      <div *ngIf="exportError" class="alert alert-danger">
        <i class="fas fa-exclamation-triangle me-2"></i>
        {{ exportError }}
      </div>
    </div>

    <div slot="footer" class="modal-footer-buttons">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="closeExportModal()"
        [disabled]="isExporting">
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-success"
        (click)="exportToExcel()"
        [disabled]="isExporting || loadingExportColumns">
        <span *ngIf="isExporting" class="spinner-border spinner-border-sm me-2"></span>
        <i *ngIf="!isExporting" class="fas fa-file-excel me-2"></i>
        {{ isExporting ? 'Exportando...' : 'Exportar' }}
      </button>
    </div>
  </app-modal>

</app-side-menu>